var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"toolHeader"}),_vm._v(" "),_c('div',{staticClass:"main__column shiftUp"},[_c('ResultsTable',{attrs:{"recommendations":_vm.$route.params.recommendations}})],1),_vm._v(" "),_c('div',{staticClass:"main__column"},[_c('SkillsCloud',{attrs:{"skills":_vm.$route.params.skills}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }